import { LogEntry } from '../models/logentry';

export abstract class LogProvider {
    public abstract log(error: LogEntry): Promise<void>;
    public abstract info(error: LogEntry): Promise<void>;
    public abstract debug(error: LogEntry): Promise<void>;
    public abstract warn(error: LogEntry): Promise<void>;
    public abstract error(error: LogEntry): Promise<void>;
}
